var _style, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:#2B3544;}\r\n\t.st1{fill:#E0E0D1;}\r\n\t.st2{opacity:0.2;fill:#231F20;}\r\n\t.st3{fill:#4F5D73;}\r\n\t.st4{opacity:0.2;}\r\n\t.st5{fill:#231F20;}\r\n\t.st6{fill:none;stroke:#e9b32b;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st7{fill:#e9b32b;stroke:#e9b32b;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st8{fill:#F5CF87;stroke:#C75C5C;stroke-width:2;stroke-miterlimit:10;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -223,
    y: -1765,
    className: "st0",
    width: 608,
    height: 1984
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20,50c0,1.1-0.9,2-2,2h-2c-1.1,0-2-0.9-2-2V39c0-1.1,0.9-2,2-2h2c1.1,0,2,0.9,2,2V50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50,50c0,1.1-0.9,2-2,2h-2c-1.1,0-2-0.9-2-2V39c0-1.1,0.9-2,2-2h2c1.1,0,2,0.9,2,2V50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20,48c0,1.1-0.9,2-2,2h-2c-1.1,0-2-0.9-2-2V37c0-1.1,0.9-2,2-2h2c1.1,0,2,0.9,2,2V48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50,48c0,1.1-0.9,2-2,2h-2c-1.1,0-2-0.9-2-2V37c0-1.1,0.9-2,2-2h2c1.1,0,2,0.9,2,2V48z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44,37H20c-3.3,0-6-2.7-6-6l0-0.4l2-10.1C17,17,19.2,15,22,15h20c2.8,0,5,2,5.9,5.5l0,0.1L50,31 C50,34.3,47.3,37,44,37z M18,31.2c0.1,1,0.9,1.8,2,1.8h24c1,0,1.9-0.8,2-1.8l-1.9-9.7C43.8,20.7,43.2,19,42,19H22 c-1.2,0-1.8,1.7-2.1,2.5L18,31.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48,29c0,2.2-1.8,4-4,4H20c-2.2,0-4-1.8-4-4l2-10c0.5-2,1.8-4,4-4h20c2.2,0,3.5,2,4,4L48,29z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52,42c0,2.2-1.8,4-4,4H16c-2.2,0-4-1.8-4-4v-5c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4V42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48,48H16c-3.3,0-6-2.7-6-6v-5c0-3.3,2.7-6,6-6h32c3.3,0,6,2.7,6,6v5C54,45.3,51.3,48,48,48z M16,35 c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2h32c1.1,0,2-0.9,2-2v-5c0-1.1-0.9-2-2-2H16z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M52,40c0,2.2-1.8,4-4,4H16c-2.2,0-4-1.8-4-4v-5c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4V40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M21,38c0,2.2-1.8,4-4,4l0,0c-2.2,0-4-1.8-4-4l0,0c0-2.2,1.8-4,4-4l0,0C19.2,34,21,35.8,21,38L21,38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M51,38c0,2.2-1.8,4-4,4l0,0c-2.2,0-4-1.8-4-4l0,0c0-2.2,1.8-4,4-4l0,0C49.2,34,51,35.8,51,38L51,38z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.ee87e72099d30b6e478857b4707b7e2d.svg";
export { ForwardRef as ReactComponent };